// -----------Importar Componentes de Terceros------------------
import { alpha, styled } from '@mui/material/styles';
import InputBase from '@mui/material/InputBase';

// -------------Valores Constantes-------------------------------
const BootstrapInput = styled(InputBase)(({ theme }) => ({
    'label + &': {
      marginTop: theme.spacing(3),
    },
    "& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button": {
      display: "none",
    },
    "& input[type=number]": {
      MozAppearance: "textfield",
    },
    '& .MuiInputBase-input': {
      borderRadius: 5,
      position: 'relative',
      backgroundColor: theme.palette.mode === 'light' ? 'white' : '#1A2027',
      border: '1px solid',
      borderColor: theme.palette.mode === 'light' ? '#E0E3E7' : '#2D3843',
      fontSize: 14,
      width: '100%',
      padding: '8px 12px',
      transition: theme.transitions.create([
        'border-color',
        'background-color',
        'box-shadow',
      ]),
      // Use the system font instead of the default Roboto font.
      fontFamily: [
        '-apple-system',
        'BlinkMacSystemFont',
        '"Segoe UI"',
        'Roboto',
        '"Helvetica Neue"',
        'Arial',
        'sans-serif',
        '"Apple Color Emoji"',
        '"Segoe UI Emoji"',
        '"Segoe UI Symbol"',
      ].join(','),
      '&:focus': {
        boxShadow: `${alpha('#FFF56B', 0.25)} 0 0 0 0.2rem`,
        borderColor: '#fbeb04',
      },
    },
  }));
  

  export default BootstrapInput;



// import React from 'react';
// import { alpha, styled } from '@mui/material/styles';
// import InputBase from '@mui/material/InputBase';
// import SearchIcon from '@mui/icons-material/Search';

// const BootstrapInput = styled(InputBase)(({ theme }) => ({
//   'label + &': { marginTop: theme.spacing(3) },
//   "& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button": { display: "none" },
//   "& input[type=number]": { MozAppearance: "textfield" },
//   '& .MuiInputBase-input': {
//     borderRadius: 5,
//     position: 'relative',
//     backgroundColor: theme.palette.mode === 'light' ? 'white' : '#1A2027',
//     border: '1px solid',
//     borderColor: theme.palette.mode === 'light' ? '#E0E3E7' : '#2D3843',
//     fontSize: 14,
//     width: '100%',
//     padding: '8px 12px 8px 36px', // espacio para el icono
//     transition: theme.transitions.create(['border-color','background-color','box-shadow']),
//     fontFamily: [
//       '-apple-system','BlinkMacSystemFont','"Segoe UI"','Roboto','"Helvetica Neue"',
//       'Arial','sans-serif','"Apple Color Emoji"','"Segoe UI Emoji"','"Segoe UI Symbol"'
//     ].join(','),
//     '&:focus': {
//       boxShadow: `${alpha('#FFF56B', 0.25)} 0 0 0 0.2rem`,
//       borderColor: '#fbeb04',
//     },
//   },
// }));

// export default function BootstrapInputWithIcon(props) {
//   return (
//     <div style={{ position: 'relative', width: '100%' }}>
//       <SearchIcon
//         sx={{
//           position: 'absolute',
//           left: 10,
//           top: '50%',
//           transform: 'translateY(-50%)',
//           color: '#D14081',
//           pointerEvents: 'none',
//         }}
//       />
//       <BootstrapInput {...props} />
//     </div>
//   );
// }


// // -----------Importar Componentes de Terceros------------------
// // -----------Importar Componentes de Terceros------------------
// import React from 'react';
// import { alpha, styled } from '@mui/material/styles';
// import InputBase from '@mui/material/InputBase';
// import SearchIcon from '@mui/icons-material/Search'; // 👈 Icono agregado

// // -------------Valores Constantes-------------------------------
// const StyledInput = styled(InputBase)(({ theme }) => ({
//   'label + &': {
//     marginTop: theme.spacing(3),
//   },
//   "& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button": {
//     display: "none",
//   },
//   "& input[type=number]": {
//     MozAppearance: "textfield",
//   },
//   '& .MuiInputBase-input': {
//     borderRadius: 5,
//     position: 'relative',
//     backgroundColor: theme.palette.mode === 'light' ? 'white' : '#1A2027',
//     border: '1px solid',
//     borderColor: theme.palette.mode === 'light' ? '#E0E3E7' : '#2D3843',
//     fontSize: 14,
//     width: '100%',
//     padding: '8px 12px 8px 36px', // 👈 deja espacio para el ícono
//     transition: theme.transitions.create([
//       'border-color',
//       'background-color',
//       'box-shadow',
//     ]),
//     fontFamily: [
//       '-apple-system',
//       'BlinkMacSystemFont',
//       '"Segoe UI"',
//       'Roboto',
//       '"Helvetica Neue"',
//       'Arial',
//       'sans-serif',
//       '"Apple Color Emoji"',
//       '"Segoe UI Emoji"',
//       '"Segoe UI Symbol"',
//     ].join(','),
//     '&:focus': {
//       boxShadow: `${alpha('#FFF56B', 0.25)} 0 0 0 0.2rem`,
//       borderColor: '#fbeb04',
//     },
//   },
// }));

// // -------------Componente Final-------------------------------
// export default function BootstrapInput(props) {
//   return (
//     <div style={{ position: 'relative', width: '100%' }}>
//       {/* Icono fijo a la izquierda */}
//       <SearchIcon
//         sx={{
//           position: 'absolute',
//           left: '10px',
//           top: '50%',
//           transform: 'translateY(-50%)',
//           color: '#D14081',
//           pointerEvents: 'none',
//         }}
//       />
//       {/* Input con padding ajustado */}
//       <StyledInput {...props} />
//     </div>
//   );
// }
